import Vue from 'vue';
import ElementUI from '@baidu/acud-element-ui';
import '@baidu/acud-element-theme';
import enLang from '@baidu/acud-element-ui/lib/locale/lang/en';
import VueClipboard from 'vue-clipboard2';

import {prepareLanguage} from '@/utils/bootstrap';
import '@/common/ClassComponentHooks';
import '@/common/monitor'; // 添加监控
import useDirective from '@/utils/directive';
import '@/styles/reset.scss';
import 'driver.js/dist/driver.css';
import App from './App.vue';
import pligins from './common/plugin';
import i18n, {locale} from './i18n';
import router from './router';
import store from './store';
import useLoadMore from './directives/loadmore';

const VueMasonryPlugin = require('vue-masonry').VueMasonryPlugin;

Vue.config.productionTip = false;

Vue.use(VueMasonryPlugin);
// OPT: 给 VueDOMPurifyHTML 提PR，替换为这个
// Vue.use(VueDOMPurifyHTML);
useDirective(Vue);
useLoadMore(Vue);
Vue.use(VueClipboard);

prepareLanguage().then((localeStr: string) => {
    if (localeStr) {
        i18n.locale = localeStr;
    }
    // plugin中包含与语言相关的设置，所以放到这里
    Vue.use(pligins);
    Vue.use(ElementUI, {locale: locale.isEnglish ? enLang : undefined});
    new Vue({
        router,
        store,
        i18n,
        render: h => h(App),
    }).$mount('#app');
});
